<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="flex w-full flex-col justify-center gap-4 rounded-md">
  <div class="form-group">
    <label for="name" class="font-semibold">
      {{ 'common.name' | translate }}
    </label>
    <input
      id="name"
      type="text"
      formControlName="name"
      class="border-default bg-elevated focus:ring-accent-focus mt-1 w-full rounded-md border-2 py-2 ps-2 text-sm text-zinc-900 placeholder:text-zinc-400 focus:ring-2 focus:outline-none dark:text-white dark:placeholder:text-zinc-500" />
    @if (form.get('name')?.invalid && form.get('name')?.touched) {
      <div class="mt-1 text-sm text-red-500">
        @if (form.get('name')?.errors?.['required']) {
          <div>{{ 'form.error.required' | translate }}</div>
        }
        @if (form.get('name')?.errors?.['minlength']) {
          <div>
            {{
              'form.error.minlength' | translate: form.get('name')?.errors?.['minlength']
            }}
          </div>
        }
      </div>
    }
  </div>

  <div class="form-group">
    <label for="description" class="font-semibold">
      {{ 'common.description' | translate }}
    </label>
    <div class="relative mt-1">
      <textarea
        id="description"
        formControlName="description"
        rows="3"
        class="border-default bg-elevated h-[5rem] w-full rounded-md border-2 py-2 ps-2">
      </textarea>
    </div>
  </div>

  <div class="form-group">
    <label for="tags" class="font-semibold">
      {{ 'common.tags' | translate }}
    </label>
    <div class="mt-1">
      <app-tags-input [id]="'tags'" formControlName="tags" />
    </div>
  </div>

  <div class="mt-2 flex w-full justify-center gap-10">
    <button
      type="button"
      (click)="onCancel()"
      class="btn-zinc w-full px-4 py-2 disabled:opacity-50">
      {{ 'common.cancel' | translate }}
    </button>
    <button
      type="submit"
      [disabled]="form.invalid"
      [class.opacity-50]="form.invalid"
      class="btn-primary w-full px-4 py-2">
      {{ 'common.submit' | translate }}
    </button>
  </div>
</form>
